import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getKdramaRecommendations } from '../components/API';
import { Box, Typography, Card, CardContent, CardMedia } from '@mui/material';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

function Recommendations() {
    const { id } = useParams();
    const [recommendations, setRecommendations] = useState([]);

    useEffect(() => {
        const fetchRecommendations = async () => {
            try {
                const data = await getKdramaRecommendations(id);
                // Filtrer les résultats par langue d'origine
                const filteredResults = data.results.filter(recommendation => recommendation.original_language === 'ko');

                setRecommendations(filteredResults);
            } catch (error) {
                console.error('Erreur lors de la récupération des recommandations:', error);
            }
        };

        fetchRecommendations();
    }, [id]);

    const navigate = useNavigate();
    const navToKdramaDetails = (id) => {
        navigate(`/kdrama/${id}`);
    };

    return (
        <Box sx={{ marginTop: '2rem', padding: '0 2rem', mb: '2rem' }}>
            <Typography variant="h5" sx={{ fontFamily: "SUSE, sans-serif", color: 'white', marginBottom: '1rem', textAlign: 'center', fontWeight: 'bold' }}>
                Recommandations
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 2 }}>
                {recommendations.slice(0, 8).map((rec) => {
                    const ratingPercentage = rec.vote_average * 10; // Calculez le pourcentage ici
                    return (
                        <Card
                            onClick={() => navToKdramaDetails(rec.id)}
                            key={rec.id}
                            sx={{
                                boxShadow: 3,
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: 6
                                },
                                width: 250,
                                height: 400,
                                cursor: 'pointer',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between'
                            }}
                        >
                            <CardMedia
                                component="img"
                                sx={{ height: 300, objectPosition: 'top' }} // fixe la hauteur de l'image
                                image={`https://image.tmdb.org/t/p/w300${rec.poster_path}`}
                                alt={rec.name}
                            />
                            <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px' }}>
                                <Typography variant="body1" sx={{ fontFamily: "SUSE, sans-serif", fontWeight: 'bold' }}>{rec.name}</Typography>
                                <Box sx={{ width: 40, height: 40, ml: 2 }}>
                                    <CircularProgressbar
                                        value={ratingPercentage}
                                        text={`${Math.round(ratingPercentage)}%`}
                                        styles={buildStyles({
                                            textColor: 'black',
                                            strokeLinecap: 'butt',
                                            pathColor: '#21d07a',
                                            trailColor: '#204529',
                                            textSize: '30px',
                                            fontWeight: 'bold',
                                        })}
                                    />
                                </Box>
                            </CardContent>
                        </Card>
                    );
                })}
            </Box>
        </Box>
    );
}

export default Recommendations;
